// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Ubw2","amount":"Amount_amount__eO5aY","tip":"Amount_tip__hTLXA","tipHeader":"Amount_tipHeader__2CeKH","tipsWrap":"Amount_tipsWrap__vO-NM"};